export const messages = {
    en: {
      notDone: {
        title: "This page is under<br/>development"
      },
      sponsor: {
        title: "Support the author",
        intro: "If my work helps you and you'd like to support it, you can use any wallet below.",
        copy: "Copy",
        copied: "Copied!",
        notice: "Thank you for your support — it helps me create more quality content and open-source."
      },
      home: {
        title: "Make your<br/>business better",
        description: "Hi! I'm a full-stack programmer with extensive experience and deep knowledge in all aspects of development.",
        highlighted_text: "Write quickly, I will be happy to solve your problem.",
        resume_btn: "Resume",
        nav: {
          about_me: {
            title: "About me",
            description: "Meet your future developer!"
          },
          portfolio: {
            title: "Portfolio",
            description: "Works that speak for themselves."
          },
          articles: {
            title: "Articles",
            description: "Your knowledge and inspiration."
          }
        }
      },
      about: {
        aboutme: {
          title: "About me",
          hello: "Hello everyone!",
          name: "My name is Dmitry",
          description: "I am a <span>Full-Stack & Software Engineer</span> with a special bias towards creativity and innovation. I am also involved in graphic design. My actions are always aimed at achieving high results and quality fulfillment of tasks. In life I am guided by self-development, I never stand still.<br><br> I maintain an active position in life, participate in hackathons. <br><span>I am a multiple winner of international hackathons, and on the state's registry of persons of outstanding ability.</span><br><br>Currently I develop open-source projects, as well as sometimes I work on freelancing. I develop websites, applications, bots, algorithms. I know how to work with big data. I am actively studying Rust for high-performance applications.",
          stats: {
            experiance: "Years<br>Experiance",
            projects: "Completed<br>Projects",
            hackathons: "Winning<br>Hackathons"
          }
        },
        techStack: {
          title: "My Tech Stack"
        },
        awards: {
          title: "Awards"
        },
        certificates: {
          title: "Certificates"
        },
        patents: {
          title: "Scientific work"
        }
      },
      portfolio: {
        spectrumSecurity: {
          title: "Spectrum Security",
          description: "Spectrum Security is a small antivirus program that uses a special ML algorithm to detect viruses with 90% accuracy."
        },
        omniview: {
          title: "OmniView",
          description: "A system for simultaneous viewing and processing of streams from multiple cameras (USB/IP) with the ability to integrate into computer vision."
        },
        meowrch: {
          title: "Meowrch",
          description: "Meowrch is an Arch-based build sharpened to maximize performance, ergonomics, and beauty."
        },
        bluevein: {
          title: "BlueVein",
          description: "Cross-platform tool to automatically synchronize Bluetooth pairing keys on dual-boot systems. "
        },
        fat32Raw: {
          title: "Fat32-Raw",
          description: "Rust library for working with FAT32 partitions and images. Provides low-level access to the FAT32 file system with support for reading, writing, creating, and deleting files and directories."
        },
        nemoTags: {
          title: "Nemo Tags",
          description: "Tag system for Nemo File Manager"
        },
        pixelGan: {
          title: "PixelGAN",
          description: "A tool designed to improve the quality of photos and videos. It uses a generative-adversarial network algorithm."
        },
        terraWing: {
          title: "TerraWing",
          description: "TerraWing is a service for recognizing obstacles in the path of UAVs and classifying them. Our solution is designed for use in the agro-industrial complex."
        },
        defectSenseAI: {
          title: "DefectSenseAI",
          description: "DefectSenseAI is a service for detecting and classifying production defects and various defects in photographs."
        },
        urbanQuanta: {
          title: "UrbanQuanta",
          description: "Optimization of road traffic on a graph of city streets using quantum-inspired methods."
        },
        pyTypingCourse: {
          title: "PyTypingCourse",
          description: "A course for an in-depth study of typing in the Python programming language"
        }
      },
      articles: {
        title: "Latest Articles",
        back: "Back to Articles",
        readMore: "Read more",
        published: "Published",
        updated: "Updated"
      },
      resume: {
        preparingPdf: "Preparing PDF…",
        downloadPdf: "Download PDF",
        patents: "Patents",
        awards: "Awards",
        certificates: "Certificates",
        page: "page",
        pdfNotFound: "PDF not found at {url}\nIf this is production, ensure it's deployed at the project path.\nLocally — run npm run build:pdf."
      },
      reviews: {
        title: "Reviews",
        leave: "Leave a review",
        closeForm: "Close form",
        yourRating: "Your rating",
        yourText: "Your review",
        textPlaceholder: "Tell others about your experience...",
        yourNameOptional: "Your name (optional)",
        namePlaceholder: "Company or person name",
        submitOnGithub: "Submit on GitHub",
        submit: "Submit",
        reviews: "reviews",
        opensInNewTab: "A new Discussion will open in a new tab.",
        openHere: "Open here",
        copyLink: "Copy link",
        showMore: "Show more",
        showLess: "Show less",
        noReviews: "No reviews yet",
        loading: "Loading reviews...",
        loadError: "Failed to load reviews",
        titleForDiscussion: "Review"
      }
    },
    ru: {
      notDone: {
        title: "Эта страница находится на<br/>стадии разработки"
      },
      sponsor: {
        title: "Поддержать автора",
        intro: "Если вам не безразлична моя работа и вы хотите поддержать её — воспользуйтесь любым удобным кошельком ниже.",
        copy: "Скопировать",
        copied: "Скопировано!",
        notice: "Спасибо за поддержку — это помогает мне делать больше качественного контента и open-source."
      },
      home: {
        title: "Сделай cвой<br/>бизнес лучше",
        description: "Привет! Я FullStack программист с большим опытом и глубокими знаниями во всех аспектах разработки.",
        highlighted_text: "Пишите скорее, буду рад решить вашу проблему.",
        resume_btn: "Резюме",
        nav: {
          about_me: {
            title: "Обо мне",
            description: "Познакомьтесь с вашим будущим разработчиком!"
          },
          portfolio: {
            title: "Портфолио",
            description: "Работы, которые говорят сами за себя."
          },
          articles: {
            title: "Статьи",
            description: "Ваши знания и вдохновение."
          }
        }
      },
      about: {
        aboutme: {
          title: "Обо мне",
          hello: "Привет всем!",
          name: "Меня зовут Дмитрий",
          description: "Я <span>Full-Stack & Software Engineer</span> с особым уклоном в сторону творчества и инноваций. Так-же занимаюсь графическим дизайном. Мои действия всегда направлены на достижение высоких результатов и качественное выполнение поставленных задач. В жизни руководствуюсь саморазвитием, никогда не стою на месте.<br><br> Сохраняю активную жизненную позицию, участвую в хакатонах. <br><span>Я многократный победитель международных хакатонов, вхожу в государственный реестр лиц выдающихся способностей.</span><br><br>В настоящее время занимаюсь разработкой open-source проектов, а также иногда работаю на фрилансе. Разрабатываю сайты, приложения, ботов, алгоритмы. Я знаю, как работать с большими данными. Я активно изучаю Rust для создания высокопроизводительных приложений.",
          stats: {
            experiance: "Лет<br>Опыта",
            projects: "Выполнено<br>проектов",
            hackathons: "Выиграно<br>Хакатонов"
          }
        },
        techStack: {
          title: "Мой тех. стек"
        },
        awards: {
          title: "Награды"
        },
        certificates: {
          title: "Сертификаты"
        },
        patents: {
          title: "Научные работы"
        }
      },
      portfolio: {
        spectrumSecurity: {
          title: "Spectrum Security",
          description: "Spectrum Security - это небольшой антивирус, использующий специальный ML алгоритм, распознающий вирусы с точностью до 90 %."
        },
        omniview: {
          title: "OmniView",
          description: "Система для одновременного просмотра и обработки потоков с нескольких камер (USB/IP) с возможностью интеграции в компьютерное зрение."
        },
        meowrch: {
          title: "Meowrch",
          description: "Meowrch - сборка, основанная на Arch, заточенная под максимальную производительность, эргономичность и красоту. "
        },
        bluevein: {
          title: "BlueVein",
          description: "Кроссплатформенный инструмент для автоматической синхронизации ключей сопряжения Bluetooth в системах с двойной загрузкой (dualboot)."
        },
        fat32Raw: {
          title: "Fat32-Raw",
          description: "Библиотека Rust для работы с разделами и образами FAT32. Обеспечивает низкоуровневый доступ к файловой системе FAT32 с поддержкой чтения, записи, создания и удаления файлов и каталогов."
        },
        nemoTags: {
          title: "Nemo Tags",
          description: "Система тегов для Nemo File Manager"
        },
        pixelGan: {
          title: "PixelGAN",
          description: "Инструмент разработанный для улучшения качества фото и видео. В нем используется алгоритм генеративно-состязательной сети."
        },
        terraWing: {
          title: "TerraWing",
          description: "TerraWing - сервис для распознавания препятствий на пути движения БПЛА и их классификации. Наше решение предназначено для использования в агропромышленном комплексе."
        },
        defectSenseAI: {
          title: "DefectSenseAI",
          description: "DefectSenseAI - сервис для обнаружения и классификации производственных браки и различных дефектов на фотографиях."
        },
        urbanQuanta: {
          title: "UrbanQuanta",
          description: "Оптимизация дорожного трафика на графе городских улиц с использованием квантово‑вдохновлённых методов."
        },
        pyTypingCourse: {
          title: "PyTypingCourse",
          description: "Курс для глубокого изучения типизации в языке программирования Python"
        }
      },
      articles: {
        title: "Последние статьи",
        back: "Назад ко всем статьям",
        readMore: "Подробнее",
        published: "Опубликовано",
        updated: "Обновлено"
      },
      resume: {
        preparingPdf: "Готовим PDF…",
        downloadPdf: "Скачать PDF",
        patents: "Патенты",
        awards: "Награды",
        certificates: "Сертификаты",
        page: "стр.",
        pdfNotFound: "PDF не найден по адресу {url}\nЕсли это прод, убедитесь что он задеплоен на путь проекта.\nЛокально — выполните npm run build:pdf."
      },
      reviews: {
        title: "Отзывы",
        leave: "Оставить отзыв",
        closeForm: "Закрыть форму",
        yourRating: "Ваша оценка",
        yourText: "Ваш отзыв",
        textPlaceholder: "Поделитесь вашим опытом...",
        yourNameOptional: "Ваше имя (необязательно)",
        namePlaceholder: "Название компании или ваше имя",
        submitOnGithub: "Отправить на GitHub",
        submit: "Отправить",
        reviews: "отзывов",
        opensInNewTab: "Откроется новая Дискуссия в новой вкладке.",
        openHere: "Открыть здесь",
        copyLink: "Скопировать ссылку",
        showMore: "Показать больше",
        showLess: "Свернуть",
        noReviews: "Пока нет отзывов",
        loading: "Загрузка отзывов...",
        loadError: "Не удалось загрузить отзывы",
        titleForDiscussion: "Отзыв"
      }
    }
  }
